module.exports = __webpack_public_path__ + "img/maestro.35553e02.png";